import axios from 'axios';
import i18n from './i18n';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_MEDIA_SERVER_URL,
  timeout: 120000,
});

httpClient.defaults.headers.common['Accept-Language'] = i18n.locale;

export default httpClient;
